import React, { useState, useEffect } from "react";
import TopicFrame from "../../../components/TopicFrame/TopicFrame";
import Subtopic from "../../../components/Subtopic/Subtopic";

const SigaPage = () => {
  const [ht, setHt] = useState("rect");
  const [st, setSt] = useState("rect");
  const [T, setT] = useState(0.5);
  const [t0, setT0] = useState(-4);
  const [pInstance, setPInstance] = useState(null); // Zustand für die p5-Instanz

  const OnHtChange = (e) => {
    setHt(e.target.value);
    if (pInstance) {
      document.getElementById("T").value = "1";

      pInstance.isDirac = pInstance.ht === "dirac";

      setHt(pInstance.ht);
      pInstance.ht = e.target.value; // Aktualisiere die ht-Funktion in der p5-Instanz

      console.log("ht changed to: ", pInstance.ht);
      pInstance.redraw(); // Beispiel: Canvas neu zeichnen, falls erforderlich
    }
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/p5.js/1.11.3/p5.js";
    script.async = true;
    document.body.appendChild(script);

    let isCos = false;
    let isDirac = false;
    let sigma = 0.005;

    script.onload = () => {
      const p5 = window.p5;
      const AccentColor = getComputedStyle(document.body).getPropertyValue("--AccentColor").trim();

      let aspect = 1;
      const xMin = parseInt(-4 * aspect);
      const xMax = parseInt(4 * aspect);
      const yMin = -1.5;
      const yMax = 8;

      let t0 = 0;
      let T = 1;

      let b1 = t0 + T / 2;
      let a2 = t0 - T / 2;

      const t02 = 0;
      const T2 = 1;

      const a1 = t02 - T2 / 2;
      const b2 = t02 + T2 / 2;

      const sketch = (p) => {
        setPInstance(p); // Speichere die p5-Instanz im Zustand

        const container = document.getElementById("canvasContainer");
        const containerWidth = container.getBoundingClientRect().width;
        const containerHeight = containerWidth / 2;

        let st = rectImpuls;
        let ht = rectImpuls;

        p.setup = () => {
          p.createCanvas(containerWidth, containerHeight).parent(container);
        };

        p.draw = () => {
          p.background(255);
          p.noFill();

          b1 = t0 + T / 2;
          a2 = t0 - T / 2;

          drawst(st, t02, T2);
          drawht(ht, t0, T);

          p.stroke(AccentColor);
          p.strokeWeight(4);

          drawConvolution(st, ht);

          p.strokeWeight(2);
          p.stroke(0);
        };

        function rectImpuls(T, t) {
          if (p.abs(t) <= T / 2) {
            return 1 / T;
          }
          return 0;
        }

        function triangularImpuls(T, t) {
          if (p.abs(t) <= T) {
            return (1 / T) * (1 - p.abs(t) / T);
          } else {
            return 0;
          }
        }

        function paralbolaImpuls(T, t) {
          if (p.abs(t) <= T * 0.5) {
            return T * (t - T * 0.5) * (t - T * 0.5);
          }
          return 0;
        }

        function cosinusFunction(T, t) {
          if (p.abs(t) <= 2) {
            return Math.sin(2 * 3.1415 * t);
          }
          return 0;
        }

        function diracImpuls(T, t) {
          if (0 < t && t <= sigma) {
            return 1 / sigma;
          }
          return 0;
        }

        function diracImpules(T, t) {
          return diracImpuls(T, t) + 0.5 * diracImpuls(T, t - T);
        }

        function drawst(impuls, t0, T) {
          p.beginShape();
          for (let x = xMin; x <= xMax; x += 0.01) {
            let y = impuls(T, x - t0);
            p.vertex(p.map(x, xMin, xMax, 0, containerWidth), p.map(y, yMin, yMax, containerHeight, 0));
          }
          p.endShape();
        }

        function drawht(impuls, t0, T) {
          p.beginShape();
          for (let x = xMin; x <= xMax; x += 0.01) {
            let y = impuls(T, -x + t0);
            if (isDirac) {
              y *= sigma;
            }
            p.vertex(p.map(x, xMin, xMax, 0, containerWidth), p.map(y, yMin, yMax, containerHeight, 0));
          }
          p.endShape();
        }

        function drawConvolution(st, ht) {
          let y = 0;
          p.beginShape();
          for (let x = xMin; x <= t0; x += 0.01) {
            y = convolution(st, ht, x);
            p.vertex(p.map(x, xMin, xMax, 0, containerWidth), p.map(y, yMin, yMax, containerHeight, 0));
          }
          p.endShape();
        }

        function convolution(st, ht, t) {
          let a = -2;
          let b = 2;
          let tau1, tau2, y1, y2;

          let dtau = 0.01;
          if (isDirac) {
            dtau = sigma;
          } else {
            dtau = 0.01;
          }
          let result = 0;

          tau1 = a;
          tau2 = a + dtau;

          for (let i = a; i < b; i += dtau) {
            y1 = st(T2, tau1) * ht(T, t - tau1);
            y2 = st(T2, tau2) * ht(T, t - tau2);

            result += (dtau * (y1 + y2)) / 2;
            tau1 = tau2;
            tau2 += dtau;
          }

          return result;
        }
      };

      new p5(sketch);
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <TopicFrame topicType="signalTheorie" entryNumber={4}>
        <Subtopic>
          <div className="canvasContainer">
            <div id="canvasContainer"></div>
            <div>
              <label htmlFor="htDropdown">h(t):&nbsp;</label>
              <select className="boxShadow" id="htDropdown" value={ht} onChange={OnHtChange}>
                <option value="rect">rect impuls</option>
                <option value="triangular">triangular impuls</option>
                <option value="parabola">parabola function</option>
                <option value="dirac">dirac impuls</option>
              </select>
              <label htmlFor="stDropdown">s(t):&nbsp;</label>
              <select className="boxShadow" id="stDropdown" value={st} onChange={(e) => setSt(e.target.value)}>
                <option value="rect">rect impuls</option>
                <option value="triangular">triangular impuls</option>
                <option value="parabola">parabola function</option>
                <option value="cosinus">cosinus function</option>
              </select>
              <input
                className="sliderWithLabel"
                type="range"
                min="0.5"
                max="2"
                value={T}
                step="0.5"
                id="T"
                onChange={(e) => setT(parseFloat(e.target.value))}
              />
            </div>
          </div>
          <div className="sliderContainer">
            <input
              type="range"
              min="-4"
              max="4"
              value={t0}
              step="0.05"
              id="t0"
              onChange={(e) => setT0(parseFloat(e.target.value))}
            />
          </div>
        </Subtopic>
      </TopicFrame>
    </>
  );
};

export default SigaPage;
